export const mapLinear = (x, a1, a2, b1, b2) => {
  return b1 + ((x - a1) * (b2 - b1)) / (a2 - a1)
}

export const mapRange = (in_min, in_max, input, out_min, out_max) => {
  return ((input - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
}

export const clamp = (x, min, max) => {
  return Math.min(Math.max(x, min), max)
}

export const lerp = (a, b, n) => {
  return (1 - n) * a + n * b
}
